export default __webpack_public_path__ + "static/media/Acedol-SR-eng.9f3a6222.jpg";